var map = {
	"./2playerRoomsPlayed_1000000.png": 1789,
	"./2playerRoomsPlayed_100000_250000.png": 1790,
	"./2playerRoomsPlayed_10000_25000.png": 1791,
	"./2playerRoomsPlayed_1000_2000.png": 1792,
	"./2playerRoomsPlayed_100_250.png": 1793,
	"./2playerRoomsPlayed_10_50.png": 1794,
	"./2playerRoomsPlayed_1_5.png": 1795,
	"./2playerRoomsPlayed_2000_3000.png": 1796,
	"./2playerRoomsPlayed_250000_500000.png": 1797,
	"./2playerRoomsPlayed_25000_50000.png": 1798,
	"./2playerRoomsPlayed_250_500.png": 1799,
	"./2playerRoomsPlayed_3000_5000.png": 1800,
	"./2playerRoomsPlayed_500000_1000000.png": 1801,
	"./2playerRoomsPlayed_50000_75000.png": 1802,
	"./2playerRoomsPlayed_5000_10000.png": 1803,
	"./2playerRoomsPlayed_500_750.png": 1804,
	"./2playerRoomsPlayed_50_100.png": 1805,
	"./2playerRoomsPlayed_5_10.png": 1806,
	"./2playerRoomsPlayed_75000_100000.png": 1807,
	"./2playerRoomsPlayed_750_1000.png": 1808,
	"./3playerRoomsPlayed_1000000.png": 1809,
	"./3playerRoomsPlayed_100000_250000.png": 1810,
	"./3playerRoomsPlayed_10000_25000.png": 1811,
	"./3playerRoomsPlayed_1000_2000.png": 1812,
	"./3playerRoomsPlayed_100_250.png": 1813,
	"./3playerRoomsPlayed_10_50.png": 1814,
	"./3playerRoomsPlayed_1_5.png": 1815,
	"./3playerRoomsPlayed_2000_3000.png": 1816,
	"./3playerRoomsPlayed_250000_500000.png": 1817,
	"./3playerRoomsPlayed_25000_50000.png": 1818,
	"./3playerRoomsPlayed_250_500.png": 1819,
	"./3playerRoomsPlayed_3000_5000.png": 1820,
	"./3playerRoomsPlayed_500000_1000000.png": 1821,
	"./3playerRoomsPlayed_50000_75000.png": 1822,
	"./3playerRoomsPlayed_5000_10000.png": 1823,
	"./3playerRoomsPlayed_500_750.png": 1824,
	"./3playerRoomsPlayed_50_100.png": 1825,
	"./3playerRoomsPlayed_5_10.png": 1826,
	"./3playerRoomsPlayed_75000_100000.png": 1827,
	"./3playerRoomsPlayed_750_1000.png": 1828,
	"./4playerRoomsPlayed_1000000.png": 1829,
	"./4playerRoomsPlayed_100000_250000.png": 1830,
	"./4playerRoomsPlayed_10000_25000.png": 1831,
	"./4playerRoomsPlayed_1000_2000.png": 1832,
	"./4playerRoomsPlayed_100_250.png": 1833,
	"./4playerRoomsPlayed_10_50.png": 1834,
	"./4playerRoomsPlayed_1_5.png": 1835,
	"./4playerRoomsPlayed_2000_3000.png": 1836,
	"./4playerRoomsPlayed_250000_500000.png": 1837,
	"./4playerRoomsPlayed_25000_50000.png": 1838,
	"./4playerRoomsPlayed_250_500.png": 1839,
	"./4playerRoomsPlayed_3000_5000.png": 1840,
	"./4playerRoomsPlayed_500000_1000000.png": 1841,
	"./4playerRoomsPlayed_50000_75000.png": 1842,
	"./4playerRoomsPlayed_5000_10000.png": 1843,
	"./4playerRoomsPlayed_500_750.png": 1844,
	"./4playerRoomsPlayed_50_100.png": 1845,
	"./4playerRoomsPlayed_5_10.png": 1846,
	"./4playerRoomsPlayed_75000_100000.png": 1847,
	"./4playerRoomsPlayed_750_1000.png": 1848,
	"./Zaudējums kā Lielajam - 0 punkti.png": 1849,
	"./Zaudējums kā Lielajam - 30 punkti.png": 1850,
	"./Zaudējums kā Lielajam - 60 punkti.png": 1851,
	"./balance_10000000.png": 1852,
	"./balance_1000000_3000000.png": 1853,
	"./balance_100000_250000.png": 1854,
	"./balance_10000_25000.png": 1855,
	"./balance_1000_2500.png": 1856,
	"./balance_250000_500000.png": 1857,
	"./balance_25000_50000.png": 1858,
	"./balance_2500_5000.png": 1859,
	"./balance_3000000_5000000.png": 1860,
	"./balance_5000000_10000000.png": 1861,
	"./balance_500000_1000000.png": 1862,
	"./balance_50000_75000.png": 1863,
	"./balance_5000_7500.png": 1864,
	"./balance_75000_100000.png": 1865,
	"./balance_7500_10000.png": 1866,
	"./bonusSpins_1000.png": 1867,
	"./bonusSpins_100_250.png": 1868,
	"./bonusSpins_10_15.png": 1869,
	"./bonusSpins_15_20.png": 1870,
	"./bonusSpins_20_25.png": 1871,
	"./bonusSpins_250_500.png": 1872,
	"./bonusSpins_25_30.png": 1873,
	"./bonusSpins_30_40.png": 1874,
	"./bonusSpins_3_5.png": 1875,
	"./bonusSpins_40_50.png": 1876,
	"./bonusSpins_500_1000.png": 1877,
	"./bonusSpins_50_75.png": 1878,
	"./bonusSpins_5_7.png": 1879,
	"./bonusSpins_75_100.png": 1880,
	"./bonusSpins_7_10.png": 1881,
	"./dealtNoTrumps_1.png": 1113,
	"./dealtOnly789_1.png": 1114,
	"./dealtOnlyQueensJacks_1.png": 1115,
	"./earnedInADay_100000_250000.png": 1882,
	"./earnedInADay_10000_15000.png": 1883,
	"./earnedInADay_1000_1500.png": 1884,
	"./earnedInADay_15000_25000.png": 1885,
	"./earnedInADay_1500_2000.png": 1886,
	"./earnedInADay_2000_3000.png": 1887,
	"./earnedInADay_250000_500000.png": 1888,
	"./earnedInADay_25000_50000.png": 1889,
	"./earnedInADay_3000_5000.png": 1890,
	"./earnedInADay_500000.png": 1891,
	"./earnedInADay_50000_75000.png": 1892,
	"./earnedInADay_5000_7500.png": 1893,
	"./earnedInADay_75000_100000.png": 1894,
	"./earnedInADay_7500_10000.png": 1895,
	"./earnedInADay_750_1000.png": 1896,
	"./fastGamesPlayed_1000000.png": 1897,
	"./fastGamesPlayed_100000_250000.png": 1898,
	"./fastGamesPlayed_10000_50000.png": 1899,
	"./fastGamesPlayed_1000_5000.png": 1900,
	"./fastGamesPlayed_100_250.png": 1901,
	"./fastGamesPlayed_10_100.png": 1902,
	"./fastGamesPlayed_1_3.png": 1903,
	"./fastGamesPlayed_250000_500000.png": 1904,
	"./fastGamesPlayed_250_500.png": 1905,
	"./fastGamesPlayed_3_5.png": 1906,
	"./fastGamesPlayed_500000_1000000.png": 1907,
	"./fastGamesPlayed_50000_100000.png": 1908,
	"./fastGamesPlayed_5000_10000.png": 1909,
	"./fastGamesPlayed_500_1000.png": 1910,
	"./fastGamesPlayed_5_10.png": 1911,
	"./galdinsLose_10000_25000.png": 1912,
	"./galdinsLose_1000_2500.png": 1913,
	"./galdinsLose_100_250.png": 1914,
	"./galdinsLose_10_25.png": 1915,
	"./galdinsLose_1_5.png": 1916,
	"./galdinsLose_25000_50000.png": 1917,
	"./galdinsLose_2500_5000.png": 1918,
	"./galdinsLose_250_500.png": 1919,
	"./galdinsLose_25_50.png": 1920,
	"./galdinsLose_50000.png": 1921,
	"./galdinsLose_5000_10000.png": 1922,
	"./galdinsLose_500_1000.png": 1923,
	"./galdinsLose_50_75.png": 1924,
	"./galdinsLose_5_10.png": 1925,
	"./galdinsLose_75_100.png": 1926,
	"./galdinsPlayed_1000000.png": 1927,
	"./galdinsPlayed_100000_250000.png": 1928,
	"./galdinsPlayed_10000_50000.png": 1929,
	"./galdinsPlayed_1000_5000.png": 1930,
	"./galdinsPlayed_100_250.png": 1931,
	"./galdinsPlayed_10_100.png": 1932,
	"./galdinsPlayed_1_3.png": 1933,
	"./galdinsPlayed_250000_500000.png": 1934,
	"./galdinsPlayed_250_500.png": 1935,
	"./galdinsPlayed_3_5.png": 1936,
	"./galdinsPlayed_500000_1000000.png": 1937,
	"./galdinsPlayed_50000_100000.png": 1938,
	"./galdinsPlayed_5000_10000.png": 1939,
	"./galdinsPlayed_500_1000.png": 1940,
	"./galdinsPlayed_5_10.png": 1941,
	"./galdinsWon_10000_25000.png": 1942,
	"./galdinsWon_1000_2500.png": 1943,
	"./galdinsWon_100_250.png": 1944,
	"./galdinsWon_10_25.png": 1945,
	"./galdinsWon_1_5.png": 1946,
	"./galdinsWon_25000_50000.png": 1947,
	"./galdinsWon_2500_5000.png": 1948,
	"./galdinsWon_250_500.png": 1949,
	"./galdinsWon_25_50.png": 1950,
	"./galdinsWon_50000.png": 1951,
	"./galdinsWon_5000_10000.png": 1952,
	"./galdinsWon_500_1000.png": 1953,
	"./galdinsWon_50_75.png": 1954,
	"./galdinsWon_5_10.png": 1955,
	"./galdinsWon_75_100.png": 1956,
	"./gamesPlayed_1000000.png": 1957,
	"./gamesPlayed_100000_250000.png": 1958,
	"./gamesPlayed_10000_50000.png": 1959,
	"./gamesPlayed_1000_5000.png": 1960,
	"./gamesPlayed_100_250.png": 1961,
	"./gamesPlayed_10_50.png": 1962,
	"./gamesPlayed_1_5.png": 1963,
	"./gamesPlayed_250000_500000.png": 1964,
	"./gamesPlayed_250_500.png": 1965,
	"./gamesPlayed_500000_1000000.png": 1966,
	"./gamesPlayed_50000_100000.png": 1967,
	"./gamesPlayed_5000_10000.png": 1968,
	"./gamesPlayed_500_1000.png": 1969,
	"./gamesPlayed_50_100.png": 1970,
	"./gamesPlayed_5_10.png": 1971,
	"./gamesWon_100000_500000.png": 1972,
	"./gamesWon_10000_25000.png": 1973,
	"./gamesWon_1000_5000.png": 1974,
	"./gamesWon_100_250.png": 1975,
	"./gamesWon_10_25.png": 1976,
	"./gamesWon_1_3.png": 1977,
	"./gamesWon_25000_100000.png": 1978,
	"./gamesWon_250_500.png": 1979,
	"./gamesWon_25_50.png": 1980,
	"./gamesWon_3_5.png": 1981,
	"./gamesWon_500000.png": 1982,
	"./gamesWon_5000_10000.png": 1983,
	"./gamesWon_500_1000.png": 1984,
	"./gamesWon_50_100.png": 1985,
	"./gamesWon_5_10.png": 1986,
	"./giftsReceived_1000_2000.png": 1987,
	"./giftsReceived_100_250.png": 1988,
	"./giftsReceived_10_25.png": 1989,
	"./giftsReceived_1_3.png": 1990,
	"./giftsReceived_2000_3000.png": 1991,
	"./giftsReceived_250_500.png": 1992,
	"./giftsReceived_25_50.png": 1993,
	"./giftsReceived_3000_5000.png": 1994,
	"./giftsReceived_3_5.png": 1995,
	"./giftsReceived_5000.png": 1996,
	"./giftsReceived_500_750.png": 1997,
	"./giftsReceived_50_75.png": 1998,
	"./giftsReceived_5_10.png": 1999,
	"./giftsReceived_750_1000.png": 2000,
	"./giftsReceived_75_100.png": 2001,
	"./giftsSent_1000_2000.png": 2002,
	"./giftsSent_100_250.png": 2003,
	"./giftsSent_10_25.png": 2004,
	"./giftsSent_1_3.png": 2005,
	"./giftsSent_2000_3000.png": 2006,
	"./giftsSent_250_500.png": 2007,
	"./giftsSent_25_50.png": 2008,
	"./giftsSent_3000_5000.png": 2009,
	"./giftsSent_3_5.png": 2010,
	"./giftsSent_5000.png": 2011,
	"./giftsSent_500_750.png": 2012,
	"./giftsSent_50_75.png": 2013,
	"./giftsSent_5_10.png": 2014,
	"./giftsSent_750_1000.png": 2015,
	"./giftsSent_75_100.png": 2016,
	"./invitedFriends_1000.png": 2017,
	"./invitedFriends_100_250.png": 2018,
	"./invitedFriends_10_15.png": 2019,
	"./invitedFriends_15_20.png": 2020,
	"./invitedFriends_1_3.png": 2021,
	"./invitedFriends_20_25.png": 2022,
	"./invitedFriends_250_500.png": 2023,
	"./invitedFriends_25_50.png": 2024,
	"./invitedFriends_3_5.png": 2025,
	"./invitedFriends_500_750.png": 2026,
	"./invitedFriends_50_75.png": 2027,
	"./invitedFriends_5_7.png": 2028,
	"./invitedFriends_750_1000.png": 2029,
	"./invitedFriends_75_100.png": 2030,
	"./invitedFriends_7_10.png": 2031,
	"./joinedTournaments_1000.png": 2032,
	"./joinedTournaments_100_250.png": 2033,
	"./joinedTournaments_10_15.png": 2034,
	"./joinedTournaments_15_20.png": 2035,
	"./joinedTournaments_20_25.png": 2036,
	"./joinedTournaments_250_500.png": 2037,
	"./joinedTournaments_25_30.png": 2038,
	"./joinedTournaments_30_40.png": 2039,
	"./joinedTournaments_3_5.png": 2040,
	"./joinedTournaments_40_50.png": 2041,
	"./joinedTournaments_500_1000.png": 2042,
	"./joinedTournaments_50_75.png": 2043,
	"./joinedTournaments_5_7.png": 2044,
	"./joinedTournaments_75_100.png": 2045,
	"./joinedTournaments_7_10.png": 2046,
	"./lightningGamesPlayed_1000000.png": 2047,
	"./lightningGamesPlayed_100000_250000.png": 2048,
	"./lightningGamesPlayed_10000_50000.png": 2049,
	"./lightningGamesPlayed_1000_5000.png": 2050,
	"./lightningGamesPlayed_100_250.png": 2051,
	"./lightningGamesPlayed_10_100.png": 2052,
	"./lightningGamesPlayed_1_3.png": 2053,
	"./lightningGamesPlayed_250000_500000.png": 2054,
	"./lightningGamesPlayed_250_500.png": 2055,
	"./lightningGamesPlayed_3_5.png": 2056,
	"./lightningGamesPlayed_500000_1000000.png": 2057,
	"./lightningGamesPlayed_50000_100000.png": 2058,
	"./lightningGamesPlayed_5000_10000.png": 2059,
	"./lightningGamesPlayed_500_1000.png": 2060,
	"./lightningGamesPlayed_5_10.png": 2061,
	"./loseLarge0_1.png": 1116,
	"./loseLarge30_1.png": 1117,
	"./loseLarge60_1.png": 1118,
	"./loseTableAllTricks_1.png": 1119,
	"./loseZoleTwoNines_1.png": 1120,
	"./maxDailyLogin_1095.png": 2062,
	"./maxDailyLogin_120_150.png": 2063,
	"./maxDailyLogin_14_30.png": 2064,
	"./maxDailyLogin_150_180.png": 2065,
	"./maxDailyLogin_180_270.png": 2066,
	"./maxDailyLogin_1_3.png": 2067,
	"./maxDailyLogin_270_365.png": 2068,
	"./maxDailyLogin_30_60.png": 2069,
	"./maxDailyLogin_365_730.png": 2070,
	"./maxDailyLogin_3_5.png": 2071,
	"./maxDailyLogin_5_7.png": 2072,
	"./maxDailyLogin_60_90.png": 2073,
	"./maxDailyLogin_730_1095.png": 2074,
	"./maxDailyLogin_7_14.png": 2075,
	"./maxDailyLogin_90_120.png": 2076,
	"./maxParties_1000.png": 2077,
	"./maxParties_100_150.png": 2078,
	"./maxParties_10_15.png": 2079,
	"./maxParties_150_200.png": 2080,
	"./maxParties_15_20.png": 2081,
	"./maxParties_200_250.png": 2082,
	"./maxParties_20_25.png": 2083,
	"./maxParties_250_500.png": 2084,
	"./maxParties_25_50.png": 2085,
	"./maxParties_3_5.png": 2086,
	"./maxParties_500_1000.png": 2087,
	"./maxParties_50_75.png": 2088,
	"./maxParties_5_7.png": 2089,
	"./maxParties_75_100.png": 2090,
	"./maxParties_7_10.png": 2091,
	"./maxSuccessionLosses_100.png": 2092,
	"./maxSuccessionLosses_10_15.png": 2093,
	"./maxSuccessionLosses_15_20.png": 2094,
	"./maxSuccessionLosses_20_25.png": 2095,
	"./maxSuccessionLosses_25_30.png": 2096,
	"./maxSuccessionLosses_30_40.png": 2097,
	"./maxSuccessionLosses_3_5.png": 2098,
	"./maxSuccessionLosses_40_50.png": 2099,
	"./maxSuccessionLosses_50_60.png": 2100,
	"./maxSuccessionLosses_5_7.png": 2101,
	"./maxSuccessionLosses_60_70.png": 2102,
	"./maxSuccessionLosses_70_80.png": 2103,
	"./maxSuccessionLosses_7_10.png": 2104,
	"./maxSuccessionLosses_80_90.png": 2105,
	"./maxSuccessionLosses_90_100.png": 2106,
	"./maxSuccessionWins_100.png": 2107,
	"./maxSuccessionWins_10_15.png": 2108,
	"./maxSuccessionWins_15_20.png": 2109,
	"./maxSuccessionWins_20_25.png": 2110,
	"./maxSuccessionWins_25_30.png": 2111,
	"./maxSuccessionWins_30_40.png": 2112,
	"./maxSuccessionWins_3_5.png": 2113,
	"./maxSuccessionWins_40_50.png": 2114,
	"./maxSuccessionWins_50_60.png": 2115,
	"./maxSuccessionWins_5_7.png": 2116,
	"./maxSuccessionWins_60_70.png": 2117,
	"./maxSuccessionWins_70_80.png": 2118,
	"./maxSuccessionWins_7_10.png": 2119,
	"./maxSuccessionWins_80_90.png": 2120,
	"./maxSuccessionWins_90_100.png": 2121,
	"./mazaZolePlayed_1000000.png": 2122,
	"./mazaZolePlayed_100000_250000.png": 2123,
	"./mazaZolePlayed_10000_50000.png": 2124,
	"./mazaZolePlayed_1000_5000.png": 2125,
	"./mazaZolePlayed_10010_10000.png": 2126,
	"./mazaZolePlayed_100_250.png": 2127,
	"./mazaZolePlayed_10_100.png": 2128,
	"./mazaZolePlayed_10_1010.png": 2129,
	"./mazaZolePlayed_1_3.png": 2130,
	"./mazaZolePlayed_250000_500000.png": 2131,
	"./mazaZolePlayed_250_500.png": 2132,
	"./mazaZolePlayed_3_5.png": 2133,
	"./mazaZolePlayed_50000.png": 2134,
	"./mazaZolePlayed_500000_1000000.png": 2135,
	"./mazaZolePlayed_50000_100000.png": 2136,
	"./mazaZolePlayed_5000_10000.png": 2137,
	"./mazaZolePlayed_500_1000.png": 2138,
	"./mazaZolePlayed_5_10.png": 2139,
	"./mazaZoleWon_10000_25000.png": 2140,
	"./mazaZoleWon_1000_2500.png": 2141,
	"./mazaZoleWon_100_250.png": 2142,
	"./mazaZoleWon_10_25.png": 2143,
	"./mazaZoleWon_1_5.png": 2144,
	"./mazaZoleWon_25000_50000.png": 2145,
	"./mazaZoleWon_2500_5000.png": 2146,
	"./mazaZoleWon_250_500.png": 2147,
	"./mazaZoleWon_25_50.png": 2148,
	"./mazaZoleWon_50000.png": 2149,
	"./mazaZoleWon_5000_10000.png": 2150,
	"./mazaZoleWon_500_1000.png": 2151,
	"./mazaZoleWon_50_75.png": 2152,
	"./mazaZoleWon_5_10.png": 2153,
	"./mazaZoleWon_75_100.png": 2154,
	"./reachedTop100_1095.png": 2155,
	"./reachedTop100_120_150.png": 2156,
	"./reachedTop100_14_30.png": 2157,
	"./reachedTop100_150_180.png": 2158,
	"./reachedTop100_180_270.png": 2159,
	"./reachedTop100_1_3.png": 2160,
	"./reachedTop100_270_365.png": 2161,
	"./reachedTop100_30_60.png": 2162,
	"./reachedTop100_365_730.png": 2163,
	"./reachedTop100_3_5.png": 2164,
	"./reachedTop100_5_7.png": 2165,
	"./reachedTop100_60_90.png": 2166,
	"./reachedTop100_730_1095.png": 2167,
	"./reachedTop100_7_14.png": 2168,
	"./reachedTop100_90_120.png": 2169,
	"./reachedTournamentTop10_100_250.png": 2170,
	"./reachedTournamentTop10_10_15.png": 2171,
	"./reachedTournamentTop10_15_20.png": 2172,
	"./reachedTournamentTop10_1_3.png": 2173,
	"./reachedTournamentTop10_20_25.png": 2174,
	"./reachedTournamentTop10_250_500.png": 2175,
	"./reachedTournamentTop10_25_30.png": 2176,
	"./reachedTournamentTop10_30_35.png": 2177,
	"./reachedTournamentTop10_35_50.png": 2178,
	"./reachedTournamentTop10_3_5.png": 2179,
	"./reachedTournamentTop10_500.png": 2180,
	"./reachedTournamentTop10_50_75.png": 2181,
	"./reachedTournamentTop10_5_7.png": 2182,
	"./reachedTournamentTop10_75_100.png": 2183,
	"./reachedTournamentTop10_7_10.png": 2184,
	"./storePurchase_100_250.png": 2185,
	"./storePurchase_10_15.png": 2186,
	"./storePurchase_15_20.png": 2187,
	"./storePurchase_1_2.png": 2188,
	"./storePurchase_20_25.png": 2189,
	"./storePurchase_250_500.png": 2190,
	"./storePurchase_25_30.png": 2191,
	"./storePurchase_2_3.png": 2192,
	"./storePurchase_30_35.png": 2193,
	"./storePurchase_35_50.png": 2194,
	"./storePurchase_3_5.png": 2195,
	"./storePurchase_500.png": 2196,
	"./storePurchase_50_75.png": 2197,
	"./storePurchase_5_10.png": 2198,
	"./storePurchase_75_100.png": 2199,
	"./suggestedToFriends_1000.png": 2200,
	"./suggestedToFriends_100_250.png": 2201,
	"./suggestedToFriends_10_15.png": 2202,
	"./suggestedToFriends_15_25.png": 2203,
	"./suggestedToFriends_1_3.png": 2204,
	"./suggestedToFriends_250_500.png": 2205,
	"./suggestedToFriends_25_50.png": 2206,
	"./suggestedToFriends_3_5.png": 2207,
	"./suggestedToFriends_500_750.png": 2208,
	"./suggestedToFriends_50_75.png": 2209,
	"./suggestedToFriends_5_7.png": 2210,
	"./suggestedToFriends_750_1000.png": 2211,
	"./suggestedToFriends_75_100.png": 2212,
	"./suggestedToFriends_7_10.png": 2213,
	"./supportMessagesSent_1000.png": 2214,
	"./supportMessagesSent_100_250.png": 2215,
	"./supportMessagesSent_10_15.png": 2216,
	"./supportMessagesSent_15_20.png": 2217,
	"./supportMessagesSent_1_2.png": 2218,
	"./supportMessagesSent_20_25.png": 2219,
	"./supportMessagesSent_250_500.png": 2220,
	"./supportMessagesSent_25_50.png": 2221,
	"./supportMessagesSent_2_3.png": 2222,
	"./supportMessagesSent_3_5.png": 2223,
	"./supportMessagesSent_500_1000.png": 2224,
	"./supportMessagesSent_50_75.png": 2225,
	"./supportMessagesSent_5_7.png": 2226,
	"./supportMessagesSent_75_100.png": 2227,
	"./supportMessagesSent_7_10.png": 2228,
	"./take0Points_1.png": 1121,
	"./take3Aces_1.png": 1122,
	"./takeTwoAces_1.png": 1123,
	"./takeTwoNines_1.png": 1124,
	"./totalPnts_10000_25000.png": 2229,
	"./totalPnts_1000_2500.png": 2230,
	"./totalPnts_100_250.png": 2231,
	"./totalPnts_10_25.png": 2232,
	"./totalPnts_25000_50000.png": 2233,
	"./totalPnts_2500_5000.png": 2234,
	"./totalPnts_250_500.png": 2235,
	"./totalPnts_25_50.png": 2236,
	"./totalPnts_50000.png": 2237,
	"./totalPnts_5000_7500.png": 2238,
	"./totalPnts_500_750.png": 2239,
	"./totalPnts_50_75.png": 2240,
	"./totalPnts_7500_10000.png": 2241,
	"./totalPnts_750_1000.png": 2242,
	"./totalPnts_75_100.png": 2243,
	"./unlimitedGamesPlayed_1000000.png": 2244,
	"./unlimitedGamesPlayed_100000_250000.png": 2245,
	"./unlimitedGamesPlayed_10000_50000.png": 2246,
	"./unlimitedGamesPlayed_1000_5000.png": 2247,
	"./unlimitedGamesPlayed_100_250.png": 2248,
	"./unlimitedGamesPlayed_10_100.png": 2249,
	"./unlimitedGamesPlayed_1_3.png": 2250,
	"./unlimitedGamesPlayed_250000_500000.png": 2251,
	"./unlimitedGamesPlayed_250_500.png": 2252,
	"./unlimitedGamesPlayed_3_5.png": 2253,
	"./unlimitedGamesPlayed_500000_1000000.png": 2254,
	"./unlimitedGamesPlayed_50000_100000.png": 2255,
	"./unlimitedGamesPlayed_5000_10000.png": 2256,
	"./unlimitedGamesPlayed_500_1000.png": 2257,
	"./unlimitedGamesPlayed_5_10.png": 2258,
	"./winLarge120_1.png": 1125,
	"./winLarge61_1.png": 1126,
	"./winLarge91_1.png": 1127,
	"./winSmall120_1.png": 1128,
	"./winSmall60_1.png": 1129,
	"./winSmall90_1.png": 1130,
	"./winZoleAll_1.png": 1131,
	"./winZoleTwoAces_1.png": 1132,
	"./zoleLose_10000_25000.png": 2259,
	"./zoleLose_1000_2500.png": 2260,
	"./zoleLose_100_250.png": 2261,
	"./zoleLose_10_25.png": 2262,
	"./zoleLose_1_5.png": 2263,
	"./zoleLose_25000_50000.png": 2264,
	"./zoleLose_2500_5000.png": 2265,
	"./zoleLose_250_500.png": 2266,
	"./zoleLose_25_50.png": 2267,
	"./zoleLose_50000.png": 2268,
	"./zoleLose_5000_10000.png": 2269,
	"./zoleLose_500_1000.png": 2270,
	"./zoleLose_50_75.png": 2271,
	"./zoleLose_5_10.png": 2272,
	"./zoleLose_75_100.png": 2273,
	"./zolePlayed_1000000.png": 2274,
	"./zolePlayed_100000_250000.png": 2275,
	"./zolePlayed_10000_50000.png": 2276,
	"./zolePlayed_1000_5000.png": 2277,
	"./zolePlayed_100_250.png": 2278,
	"./zolePlayed_10_100.png": 2279,
	"./zolePlayed_1_3.png": 2280,
	"./zolePlayed_250000_500000.png": 2281,
	"./zolePlayed_250_500.png": 2282,
	"./zolePlayed_3_5.png": 2283,
	"./zolePlayed_500000_1000000.png": 2284,
	"./zolePlayed_50000_100000.png": 2285,
	"./zolePlayed_5000_10000.png": 2286,
	"./zolePlayed_500_1000.png": 2287,
	"./zolePlayed_5_10.png": 2288,
	"./zoleWon_10000_25000.png": 2289,
	"./zoleWon_1000_2500.png": 2290,
	"./zoleWon_100_250.png": 2291,
	"./zoleWon_10_25.png": 2292,
	"./zoleWon_1_5.png": 2293,
	"./zoleWon_25000_50000.png": 2294,
	"./zoleWon_2500_5000.png": 2295,
	"./zoleWon_250_500.png": 2296,
	"./zoleWon_25_50.png": 2297,
	"./zoleWon_50000.png": 2298,
	"./zoleWon_5000_10000.png": 2299,
	"./zoleWon_500_1000.png": 2300,
	"./zoleWon_50_75.png": 2301,
	"./zoleWon_5_10.png": 2302,
	"./zoleWon_75_100.png": 2303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;